import { useNavigate } from '@tanstack/react-router'
import { Button } from '@shared/design-system/ui'
import { useMemberProductQuery } from '../api/member-access.queries'
import { useMemberSession } from '../model/member-session-store'
import { MemberAccessLayout } from './MemberAccessLayout'
import { MemberFileCard } from './MemberFileCard'
import { actions, documentEmpty, documentList, pageIntro, subtitle, title } from './member-access.css'

export function MemberFilesPage({ producerId, productId }: { producerId: string; productId: string }) {
  const navigate = useNavigate()
  const token = useMemberSession((state) => state.token)
  const product = useMemberProductQuery(productId, Boolean(token))

  if (!token) {
    void navigate({ to: '/acesso/$producerId', params: { producerId } })
    return null
  }
  if (product.data?.kind === 'course') {
    void navigate({ to: '/acesso/$producerId/cursos/$productId', params: { producerId, productId } })
    return null
  }
  if (product.isError) {
    void navigate({ to: '/acesso/$producerId/biblioteca', params: { producerId } })
    return null
  }
  const files = product.data?.kind === 'files' ? product.data.files : undefined
  const list = files?.files ?? []
  return (
    <MemberAccessLayout producerName={files?.producerName ?? 'Area de membros'} logoUrl={files?.logoUrl}>
      <header className={pageIntro}>
        <h1 className={title}>{files?.product.name ?? 'Arquivos'}</h1>
        <p className={subtitle}>
          {list.length} {list.length === 1 ? 'arquivo' : 'arquivos'}
        </p>
      </header>
      {list.length > 1 ? (
        <div className={actions}>
          <Button
            onClick={() => {
              for (const file of list) {
                window.open(file.downloadUrl, '_blank')
              }
            }}
          >
            Baixar tudo
          </Button>
        </div>
      ) : null}
      {list.length === 0 ? (
        <div className={documentEmpty}>
          <p>Nenhum arquivo liberado nesta entrega.</p>
        </div>
      ) : (
        <div className={documentList}>
          {list.map((file) => (
            <MemberFileCard
              key={file.id}
              name={file.name}
              sizeBytes={file.sizeBytes}
              onOpen={() => {
                window.open(file.downloadUrl, '_blank', 'noopener,noreferrer')
              }}
            />
          ))}
        </div>
      )}
    </MemberAccessLayout>
  )
}
